module.exports = {
  CCFIT: 'CCFIT',
  SREIS: 'SREIS',
  SCHNEIDER: 'SCHNEIDER',
  IT_EXPERIENCE: 'IT_EXPERIENCE',
};
